import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-cheque-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class ChequeTabComponent{
	@Input() desativado:boolean = false;;
}
